import axios from 'axios';
import {showToast} from "../../utils/Utils";
import {ToastType} from "../../constants/Constants";


export default class Request {
    // eslint-disable-next-line no-undef
    config = {};

    constructor(url, method, data,contentType) {
        let apiPort = "";
       
        this.config ={};

        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            apiPort = ":8080";
        }

        if (url.includes("http://") || url.includes("https://")) {
            this.config['url'] = url;
        } else {
            this.config['url'] = "https://" + window.location.hostname + apiPort + "/api" + url;
        }

        if (method) {
            this.config['method'] = method;
        } else {
            this.config['method'] = 'get';
        }

        if(data && contentType != null && contentType == "multipart/form-data"){
            this.config['data'] = data;
        }else if (data) {
            this.config['data'] = JSON.stringify(data);
        }

        this.setHeaderToken(contentType);
    }


    setHeaderToken(contentType) {
    
        if(contentType == null){
            contentType = 'application/json';
        }
        this.config['headers'] = {
            //'Accept': 'application/json',
            'Content-Type': contentType,
            'Authorization': localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null ? 'Bearer ' + localStorage.getItem('token') : "",
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Credentials': 'true',

        };
    }

    run() {
//        console.log("wait box u aç")
        const result = axios(this.config)
            .then((response) => {
         //       console.log("wait box u kapat")

                return response;
            }).catch((error) => {
                if (error.response && error.response.data.message) {
                    showToast(error.response.data.message, ToastType.ERROR, 1000);

                } else {
                    showToast(error, ToastType.ERROR, 1000);

                }

          //      console.log("wait box u kapat alert ver")
         
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem('loggedIn');
                    localStorage.removeItem('token');
                    localStorage.removeItem('username');
                    localStorage.removeItem('name');
                    
                    window.location.href = "/";
                }
                return error;
            });

        return result;

    }

}

